import m from "../../geodata/es2015/croatiaLow";
window.am4geodata_croatiaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/croatiaLow.js
// module id = null
// module chunks = 